import React, { useState, useEffect, Fragment } from 'react';
import { useTranslation } from "react-i18next";

import { Box, Paper, Typography, TextField, Button, Divider, Alert } from '@mui/material';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom'; 
import SideBar from "../Sidebar/SideBar"; // ⭐ HIER INTEGRIERT: Holt die Sidebar auf die Seite
import axios from 'axios';

// Import der existierenden User-Action
import { SET_USER_DATA } from '../../Redux/types'; 

function Profile({ userData, dispatch }) {
  const { t } = useTranslation();
  const history = useHistory();
  const [formData, setFormData] = useState({
    id: null,
    username: '',
    email: '',
    role: 1,
    first_name: '',
    last_name: '',
    phone: '',
    language: 'de',
    password: '',        // ⭐ NEU: Für die Passwort-Änderung
    confirmPassword: ''  // ⭐ NEU: Zum Abgleichen
  });
  
  const [status, setStatus] = useState({ type: '', msg: '' });

  useEffect(() => {
    document.title = `SheetAble - ${t("PageProfile.pageTitle")}`;
    if (userData) {
      setFormData({
        id: userData.id || null,
        username: userData.username || '',
        email: userData.email || '',
        role: userData.role !== undefined ? userData.role : 1,
        first_name: userData.first_name || '',
        last_name: userData.last_name || '',
        phone: userData.phone || '',
        language: userData.language || 'de',
        password: '',
        confirmPassword: ''
      });
    }
  }, [userData, t]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus({ type: '', msg: '' });

    // Passwort-Validierung vor dem Absenden
    if (formData.password && formData.password !== formData.confirmPassword) {
      setStatus({ type: 'error', msg: t("PageProfile.statusMsg_confirmPassword") });
      return;
    }

    axios.put(`/users/${formData.id}`, formData)
      .then(res => {
        setStatus({ type: 'success', msg: t("PageProfile.statusMsg_edit_success") });
        
        dispatch({
          type: SET_USER_DATA,
          payload: res.data
        });

        localStorage.setItem("user", JSON.stringify(res.data));
        setFormData(prev => ({ ...prev, password: '', confirmPassword: '' }));
        setTimeout(() => setStatus({ type: '', msg: '' }), 4000);
      })
      .catch(err => {
        console.error(t("PageProfile.statusMsg_edit_error"), err);
        setStatus({ type: 'error', msg: t("PageProfile.statusMsg_edit_error") });
      });
  };

  const handleClose = () => {
    history.push('/sheets');
  };

  const getRoleText = (roleValue) => {
    if (roleValue === 0) return `0 (${t("user.role_admin")})`;
    if (roleValue === 1) return `1 (${t("user.role_user")})`;
    return `${roleValue} (${t("user.role_unknown")})`;
  };

  return (
    <Fragment>
      {/* ⭐ SIDEBAR: Links fest verankert */}
      <SideBar />

      {/* ⭐ HAUPTCONTENT-CONTAINER: Nutzt das native CSS-Layout Ihres Projekts */}
      <div className="home_content settings" style={{ padding: "40px 20px" }}>
        
        <Box sx={{ mb: 3, maxWidth: "460px", mx: "auto", textAlign: "left" }}>
          <span className="doc_sheet">{t("PageProfile.pageTitle")}</span>
          <br />
          <span className="doc_composer">{t("PageProfile.pageDescription")}</span>
        </Box>

        {/* ⭐ EINSPALTIGES FORMAT: Zentrierte Kachel mit elegantem Schatten */}
        <Paper 
          elevation={3} 
          sx={{ 
            width: "100%", 
            maxWidth: "460px", 
            mx: "auto", 
            p: "30px 25px",
            borderRadius: "15px",
            backgroundColor: "white"
          }}
        >
          {status.msg && (
            <Alert severity={status.type} sx={{ mb: 3, borderRadius: "8px" }}>
              {status.msg}
            </Alert>
          )}

          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            
            {/* Sektion 1: Identität */}
            <Box style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <Typography variant="caption" sx={{ color: "#4f40b3", fontWeight: "bold", letterSpacing: "1px", textTransform: "uppercase" }}>
				{t("PageProfile.subtitle_section_1")}
              </Typography>
              <TextField fullWidth size="small" label="E-Mail-Adresse" value={formData.email} InputProps={{ readOnly: true }} variant="filled" />
              <TextField fullWidth size="small" label="Berechtigungsrolle" value={getRoleText(formData.role)} InputProps={{ readOnly: true }} variant="filled" />
              <TextField fullWidth variant="outlined" size="small" label="Benutzername (Username)" name="username" value={formData.username} onChange={handleInputChange} />
            </Box>

            <Divider sx={{ my: 0.5 }} />

            {/* Sektion 2: Profildaten */}
            <Box style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <Typography variant="caption" sx={{ color: "#4f40b3", fontWeight: "bold", letterSpacing: "1px", textTransform: "uppercase" }}>
   				{t("PageProfile.subtitle_section_2")}
              </Typography>
              <TextField fullWidth variant="outlined" size="small" label={t("user.givenname")} name="first_name" value={formData.first_name} onChange={handleInputChange} />
              <TextField fullWidth variant="outlined" size="small" label={t("user.lastname")} name="last_name" value={formData.last_name} onChange={handleInputChange} />
              <TextField fullWidth variant="outlined" size="small" label={t("user.phone")} name="phone" value={formData.phone} onChange={handleInputChange} />
              
              <TextField
                select fullWidth variant="outlined" size="small"
                label={t("user.language")} name="language"
                value={formData.language} onChange={handleInputChange}
                SelectProps={{ native: true }} // Gewährleistet vertikales Aufklappen
              >
                <option value="de">{t("common.langOptionDe")}</option>
                <option value="en">{t("common.langOptionEn")}</option>
              </TextField>
            </Box>

            <Divider sx={{ my: 0.5 }} />

            {/* ⭐ Sektion 3: NEU - Passwort ändern */}
            <Box style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <Typography variant="caption" sx={{ color: "#4f40b3", fontWeight: "bold", letterSpacing: "1px", textTransform: "uppercase" }}>
   				{t("PageProfile.subtitle_section_3")}
              </Typography>
              <TextField 
                fullWidth variant="outlined" size="small" type="password" 
                label={t("PageProfile.password_new")} name="password" 
                value={formData.password} onChange={handleInputChange} 
                placeholder={t("PageProfile.placeholder_password")}
				autoComplete="new-password"
              />
              <TextField 
                fullWidth variant="outlined" size="small" type="password" 
                label={t("PageProfile.password_confirm")} name="confirmPassword" 
                value={formData.confirmPassword} onChange={handleInputChange} 
                error={formData.password !== formData.confirmPassword && formData.confirmPassword !== ""}
				autoComplete="new-password"
              />
            </Box>

            {/* Sektion 4: Buttons */}
            <Box sx={{ mt: 1, display: "flex", justifyContent: "space-between", gap: "12px" }}>
              <Button 
                variant="outlined" 
                onClick={handleClose}
                sx={{ borderRadius: "8px", py: "8px", px: "20px", textTransform: "none" }}
              >
				{t("common.cancel")}
              </Button>
              <Button
                type="submit"
                variant="contained"
                sx={{ 
                  borderRadius: "8px", 
                  py: "8px", 
                  px: "25px", 
                  backgroundColor: "#4f40b3",
                  '&:hover': { backgroundColor: '#3b2f93' },
                  color: "white",
                  textTransform: "none",
                  boxShadow: "0 4px 12px rgba(79, 64, 179, 0.25)"
                }}
              >
				{t("common.save")}
              </Button>
            </Box>

          </form>
        </Paper>
      </div>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  userData: state.user.userData,
});

export default connect(mapStateToProps)(Profile);
